import React, { Suspense, useEffect, useRef } from 'react'
import Protected from '../../Protected'
import * as QueryString from 'query-string'
import useErrorHandler from '../../../hooks/useErrorHandler'
import BookmarksService from '../../../services/BookmarksService'
import { BookmarksRequest } from '../../../models/Bookmarks'
import {
  cleanupUrlEncoding,
  validataUrl,
} from '../../../utilities/commonFunctions'
import { BOOKMARKSTYPES } from '../bookmarkstypes'
import DOMPurify from 'dompurify'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'

const FormErrorDisplay = React.lazy(
  () => import('../../common/FormErrorMessages')
)

const BookmarkToMyAccount = () => {
  const mountedRef = useRef(false)
  const [userErrors, , handleErrors, ,] = useErrorHandler()
  const { inProgress } = useMsal()

  const cleanedString = cleanupUrlEncoding(location.search)

  let parsed = null
  let isSourceUrlValid = false
  try {
    parsed = QueryString.parse(cleanedString)
    isSourceUrlValid = DOMPurify.isValidAttribute('a', 'href', parsed.SourceUrl)
  } catch (error) {
    const params = new URLSearchParams(location.search)
    const sourceUrl = params.get('SourceUrl')

    isSourceUrlValid = DOMPurify.isValidAttribute('a', 'href', sourceUrl)
  }

  useEffect(() => {
    const handleBookmarkToMyAccount = async () => {
      const payload = new BookmarksRequest()

      if (
        parsed &&
        isSourceUrlValid &&
        validataUrl(parsed.SourceUrl) &&
        parsed.System != null &&
        parsed.Title != null
      ) {
        payload.type = parsed.System
        payload.title = cleanupUrlEncoding(parsed.Title)
        payload.sourceUrl = cleanupUrlEncoding(parsed.SourceUrl)

        //for awards
        if (payload.type.toLowerCase() === BOOKMARKSTYPES.AWARD.toLowerCase()) {
          payload.summaryTitle = cleanupUrlEncoding(parsed.SummaryTitle)
          payload.summaryUrl = cleanupUrlEncoding(parsed.SummaryUrl)
          BookmarksService.createBookmark(payload)
            .then(() => {
              window.location.href = '/my-account/bookmarked-awards'
            })
            .catch((error) => {
              handleErrors(error)
            })
        } else {
          BookmarksService.createBookmark(payload)
            .then(() => {
              if (
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.WEB.toLowerCase() ||
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.FAVOURITES.toLowerCase()
              ) {
                window.location.href = '/my-account/bookmarked-pages'
              } else if (
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.LEAVE.toLowerCase() ||
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.PAY.toLowerCase() ||
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.PAYPACT.toLowerCase() ||
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.SHIFT.toLowerCase() ||
                payload.type.toLowerCase() ===
                  BOOKMARKSTYPES.NOTICEREDUNDANCY.toLowerCase()
              ) {
                window.location.href = '/my-account/bookmarked-results'
              }
            })
            .catch((error) => {
              handleErrors(error)
            })
        }
      }
    }

    mountedRef.current = true
    if (mountedRef.current && inProgress === InteractionStatus.None) {
      handleBookmarkToMyAccount()
    }

    return () => {
      mountedRef.current = false
    }
  }, [inProgress])

  return (
    <Suspense fallback={null}>
      <Protected>
        <div className="content-wrapper">
          <FormErrorDisplay
            heading="Please review the following errors"
            show={userErrors?.length > 0}
            errorsList={userErrors}
          />
        </div>
      </Protected>
    </Suspense>
  )
}

export default BookmarkToMyAccount
